export default {
  profile: {
    months_one: '{{count}} Monat', months_other: '{{count}} Monate',
    period: { free: 'kostenlos', trial: 'Testzeitraum', trial5: 'Testzeitraum · 5 Tage' },
    method: { card: 'Karte · CloudPayments', crypto: 'Krypto · NOWPayments' },
    offer: { plus: 'bis zu 5 Coins · 30 Orca-AI-Fragen · Makro, Kalender, Prognose, Price Alerts, X Radar, YouTube', premium: 'bis zu 8 Coins · 55 Orca-AI-Fragen · alles aus Plus, OrcaWatch und Wall Street Digests' },
    err: {
      applying: 'Zahlung erhalten. Dein Tarif wird aktiviert — das dauert meist bis zu einer Minute.', pendingReal: 'Der Zahlungsanbieter hat die Zahlung noch nicht bestätigt. Wenn du bezahlt hast, prüfe in ein paar Minuten erneut.',
      canceled: 'Zahlung abgebrochen. Es wurde nichts abgebucht — du kannst erneut einen Tarif wählen.', expired: 'Die Zeit für die Zahlung ist abgelaufen. Erstelle eine neue Zahlung.',
      trialUsed: 'Der Plus-Test wurde für dieses Konto bereits genutzt.', missing: 'Zahlung nicht gefunden. Geh zurück zur Tarifwahl.',
      pending: 'Zahlung noch nicht bestätigt. Warte 5 Minuten und prüfe erneut.', failed: 'Zahlung fehlgeschlagen. Es wurde nichts abgebucht — versuch es erneut oder wähle eine andere Methode.',
      coinLimit: 'Im Tarif {{plan}} sind bis zu {{n}} Coins möglich.',
    },
  },
};
